import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import FilesPage from 'apps/files/page';
import { PlanMonitor } from 'apps/initiative/views/PlanMonitor';

const viewsMap = {
  '': FilesPage,
};

@withNamespaces()
@observer
class FilesPageRouter extends React.Component {
  render() {
    const View = this.props.componentFromRoute();
    return (
      <PlanMonitor>
        <View params={this.props.params} />
      </PlanMonitor>
    );
  }
}

FilesPageRouter.propTypes = {
  route: PropTypes.object,
  params: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export default routeNode(
  'workspace.spaceFiles',
  viewsMap,
  FourOhFour,
)(FilesPageRouter);
